
import { isSpbWide } from '@search/helpers/src/isRegion';

export const regionsEnumerationDie = [
    { label: 'Москва и Московская область', value: 0 },
    { label: 'Санкт-Петербург и Ленинградская область', value: 1 },
];

export function mapRegionToSelect(regionId?: number) {
    if (isSpbWide(regionId)) return regionsEnumerationDie[1].value;

    // msk & default
    return regionsEnumerationDie[0].value;
}
